import { useMemo } from 'react'
import { useAnalytics } from '@clara/events'

export const useEvents = () => {
  const analytics = useAnalytics()

  const track = (event_id: string) => analytics.track(event_id, {})

  return useMemo(
    () => ({
      onHomepage: () => analytics.page('REIMB_ENTER_HOMEPAGE', {}),
      linkingAccount: () => track('REIMB_START_LINK_BANK_ACCOUNT'),
      creatingNewReimb: () => track('REIMB_START_CREATING_NEW'),
      downloadPendingCsv: () => track('REIMB_CSV_PENDING_DOWNLOAD'),
      downloadOverviewCsv: () => track('REIMB_CSV_OVERVIEW_DOWNLOAD'),
      sendNewReimb: () => track('REIMB_SEND_NEW'),
    }),
    [analytics],
  )
}
